<template>
    <div class="CImageCropper flex bg-gray-800 p-3">
        <div class="relative flex-auto pt-full">
            <Cropper
                ref="cropper"
                class="absolute left-0 top-0 size-full bg-gray-800"
                classname="cropper"
                :src="image"
                :stencil-props="stencilProps"
                @change="handleCrop"
                @ready="handleReady"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import 'vue-advanced-cropper/dist/style.css'
import { Cropper } from 'vue-advanced-cropper'
import { ref } from 'vue'

const props = defineProps({
    image: {
        type: String,
        required: true
    },
    size: {
        type: Number,
        default: 500
    },
    stencilProps: {
        type: Object,
        default: () => ({ aspectRatio: 1 })
    }
})
const emit = defineEmits(['crop'])

const cropper = ref<InstanceType<typeof Cropper> | null>(null)

const create2dContext = (width: number, height: number) => {
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    return canvas.getContext('2d')
}

const normalizeImage = (canvas: HTMLCanvasElement, width: number, height: number) => {
    const ctx = create2dContext(width, height)
    if (ctx) {
        ctx.drawImage(canvas, 0, 0, width, height)
        return ctx.canvas.toDataURL()
    }
    return canvas.toDataURL()
}

const handleCrop = (event: any) => {
    console.log('Crop event received:', event)
    const canvas = event?.canvas
    if (!canvas) {
        console.log('No canvas found in crop event')
        return
    }
    
    const croppedImageData = normalizeImage(
        canvas,
        props.stencilProps.aspectRatio === 1 ? props.size : props.size * props.stencilProps.aspectRatio,
        props.size
    )
    
    console.log('Emitting cropped image:', croppedImageData.substring(0, 50) + '...')
    emit('crop', croppedImageData)
}

const handleReady = () => {
    console.log('Cropper ready')
    // Get initial crop when cropper is ready
    if (cropper.value) {
        const result = cropper.value.getResult()
        console.log('Initial cropper result:', result)
        const { canvas } = result
        if (canvas) {
            const croppedImageData = normalizeImage(
                canvas,
                props.stencilProps.aspectRatio === 1 ? props.size : props.size * props.stencilProps.aspectRatio,
                props.size
            )
            console.log('Emitting initial cropped image:', croppedImageData.substring(0, 50) + '...')
            emit('crop', croppedImageData)
        } else {
            console.log('No canvas in initial result')
        }
    } else {
        console.log('No cropper instance available')
    }
}
</script>
